import { observer } from "mobx-react";
import React, { Component } from "react";
import FilterGroup from "../FilterGroup";
import RadioGroup from "../../form/RadioGroup";
import RadioInput from "../../form/RadioInput";

class TimeOfDayFilter extends Component {
  render() {
    const { name, store } = this.props;

    return (
      <FilterGroup title="Time of Day">
        <RadioGroup
          name={name}
          selected={store.selectedTimeOfDay}
          onChangeHandler={store.updateSelectedTimeOfDay}
        >
          <RadioInput label="Day" value="D" />
          <RadioInput label="Night" value="N" />
          <RadioInput label="Both" value="B" />
        </RadioGroup>
      </FilterGroup>
    );
  }
}

export default observer(TimeOfDayFilter);



// WEBPACK FOOTER //
// ./src/components/filters/options/TimeOfDayFilter.js